import { signInStart, signInSuccess, signInError, signInForbidden } from "../actions/sign_in";
import userAPI from "../api/user";
import { userLogin } from "../actions/user";
import { updateCurrentRole } from "../actions/account";
import UserStore, { saveUserRole } from "../lib/user_store";
import ActionManager from "./base";
import { addRoleFetch } from "./account";
import get from "lodash/get";
import getDefaultRole from "../lib/user_roles";

class SignInActionManager extends ActionManager {
  preCall(dispatch) {
    dispatch(signInStart());
  }

  saveRole = (dispatch, role) => {
    dispatch(updateCurrentRole(role));
    saveUserRole(role);
  };

  // This is pretty ugly - we're trying to make sure that the role gets added before
  // the sign in result is added to the redux store, and handling some
  // ugly role precedence stuff.
  execute = (dispatch, getState) => {
    // Get the user's stored cookie about what role they've selcted
    const currentRole = UserStore.getUserRole();

    return userAPI.signIn(this.args.email, this.args.password).then(response => {
      if (Math.floor(response.status / 100) !== 2) {
        return response;
      }
      // If the user is signing in as a particular role, set that.
      if (this.args.forRole) {
        this.saveRole(dispatch, this.args.forRole);
      }

      return response.json().then(storedJSON => {
        response.json = () => Promise.resolve(storedJSON);
        if (!this.args.forRole || get(storedJSON, ["roles", this.args.forRole])) {
          // If the user doesn't have a saved role and isn't logging into a specific role, set their role
          // to a reasonable default depending on the roles on their account.
          if (!currentRole && !this.args.forRole) {
            this.saveRole(dispatch, getDefaultRole(storedJSON));
          }
          return response;
        }

        return addRoleFetch(storedJSON, this.args.forRole, dispatch, getState).then(
          addRoleResponse => {
            if (addRoleResponse.status === 200 || addRoleResponse.status === 204) {
              storedJSON.roles[this.args.forRole] = true;
            }
            return response;
          }
        );
      });
    });
  };

  responseOK(dispatch, json) {
    dispatch(userLogin(json));
    UserStore.save(json);
    dispatch(signInSuccess());
  }

  response400(dispatch, json) {
    this.responseError(dispatch, 400, json);
  }

  response403(dispatch, json) {
    dispatch(signInForbidden());
    this.showError(dispatch, json.message);
  }

  responseError(dispatch, statusCode, json) {
    dispatch(signInError());
    this.showError(dispatch, json.message || this.defaultErrorMessage());
  }

  catchError(dispatch) {
    dispatch(signInError());
    this.showError(dispatch, this.defaultErrorMessage());
  }

  defaultErrorMessage() {
    return "Uh oh, something went wrong signing in. Please try again later.";
  }
}

export default SignInActionManager;
